import { AreaCompetenza } from "./areaCompetenza.model";

export class GruppoTecnici {
    id: number;
    descrizione: string;
    deletable:boolean;
  }
